export default __webpack_public_path__ + "static/media/Sonido_dados.d964097c.mp3";